module.exports = __webpack_public_path__ + "img/boy_010013.467fc452.png";